module.exports = __webpack_public_path__ + "img/thumb_2021-04.36be56e7.jpg";